export default "__VITE_ASSET__Brs3UOz___"